"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var icons = _interopRequireWildcard(require("@meepshop/utils/lib/icons"));

var _StoreDesign = _interopRequireDefault(require("@meepshop/context/lib/StoreDesign"));

var _useGoToButton = _interopRequireDefault(require("./hooks/useGoToButton"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import
require("./styles/goToButton.less");

var styles = {
  "root": "meepshop-action-button__goToButton__root",
  "icon": "meepshop-action-button__goToButton__icon"
}; // graphql typescript

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var _goToButton$icon, _goToButton$icon2, _goToButton$icon3, _goToButton$icon$scal;

  var goToButton = _ref.goToButton;

  var _useContext = (0, _react.useContext)(_StoreDesign["default"]),
      colors = _useContext.colors;

  var goTo = (0, _useGoToButton["default"])(goToButton);
  if (!(goToButton !== null && goToButton !== void 0 && goToButton.isEnabled)) return null;
  var DefaultIcon = ((_goToButton$icon = goToButton.icon) === null || _goToButton$icon === void 0 ? void 0 : _goToButton$icon.__typename) !== 'DefaultIcon' ? function () {
    return null;
  } : icons[goToButton.icon.icon];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.root,
    style: {
      background: colors[4],
      boxShadow: "0 2px 10px 0 ".concat(colors[3])
    },
    onClick: function onClick() {
      return goTo();
    }
  }, ((_goToButton$icon2 = goToButton.icon) === null || _goToButton$icon2 === void 0 ? void 0 : _goToButton$icon2.__typename) !== 'DefaultIcon' ? null : /*#__PURE__*/_react["default"].createElement(DefaultIcon, {
    className: styles.icon,
    style: {
      fill: colors[3]
    }
  }), ((_goToButton$icon3 = goToButton.icon) === null || _goToButton$icon3 === void 0 ? void 0 : _goToButton$icon3.__typename) !== 'Image' ? null : /*#__PURE__*/_react["default"].createElement("img", {
    className: styles.icon,
    src: ((_goToButton$icon$scal = goToButton.icon.scaledSrc) === null || _goToButton$icon$scal === void 0 ? void 0 : _goToButton$icon$scal.w60) || '',
    alt: goToButton.icon.id
  }));
});

exports["default"] = _default;